(function () {
  const slider = document.querySelector('[data-collection-list-slider]');
  if (!slider) return;

  const countSlides = slider.dataset.countSlides;
  const wrapper = slider.closest('.collection-list-container');
  const inputs = wrapper.querySelectorAll('input[type="radio"]');

  // There is one radio button per slide (used to paginate the slider).
  // On scroll, calculate which slide is the most visible based on the width scrolled and the width of the slider.
  // Check the checkbox corresponding to the slide.
  // We add a "scrolled" class to the slider to be able to style it when scrolled.
  function onSliderScroll(event) {
    slider.classList.add('scrolled');
    const scrollWidth = event.target.scrollWidth;
    const scrollLeft = event.target.scrollLeft;
    const width = event.target.offsetWidth;
    const scrollRatio = scrollLeft / (scrollWidth - width);
    const slideIndex = Math.round(scrollRatio * (countSlides - 1));
    inputs[slideIndex].checked = true;
  }

  function onSliderMouseLeave() {
    console.log('mouse leave');
    slider.classList.remove('scrolled');
  }

  function onSliderTouchEnd() {
    console.log('touch end');
    slider.classList.remove('scrolled');
  }

  slider.addEventListener('scroll', onSliderScroll);
  slider.addEventListener('mouseleave', onSliderMouseLeave);
  slider.addEventListener('touchend', onSliderTouchEnd);
})();